import React, { RefObject, useEffect, useState } from 'react';
import {
	View,
	TextInput,
	TouchableOpacity,
	StyleSheet,
	ActivityIndicator
} from 'react-native';
import { ZenEmptyComponent, ZenIcon, ZenText, ZenToast } from 'zen-core-elements';
import { paymentSaveType } from '../../../../redux/types/sellScreenTypes';
import { Theme, ThemeConsumer } from '@rneui/themed';
import { CustomSearchBar } from '../../customSearchBar';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { config } from '../../../../shared/environment';
import { redeemGiftCardApi, toggleSplitPayment } from '../../../../redux/slices/newSellscreenPaymentSlice';
import { GiftCardDetails } from '../../../payment/paymentModule';
import CommonService from '../../../../shared/services/commonService';

let tempCode: null | string = null
const GiftCardPayment = ({ onClose, handleSave, initialValue = 0, inputRef, giftCardPayment }: { onClose: () => void, handleSave: (value: paymentSaveType) => void, initialValue?: number, inputRef: RefObject<TextInput | null>, giftCardPayment?: GiftCardDetails | null }) => {
	const dispatch = useAppDispatch()
	const { isSplitPayment, totalAmount, remainingAmount } = useAppSelector((state) => state?.NewSellscreenPaymentSlice)
	const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'
	const [code, setCode] = useState<string | null>(tempCode);
	const [loading, setLoading] = useState(false);
	const [giftCard, setGiftCard] = useState<GiftCardDetails | null>(giftCardPayment || null);
	const [isFetched, setIsFetched] = useState(false);
	const [isSufficient, setIsSufficient] = useState(false)

	const newTotalAmount = isSplitPayment ? (remainingAmount + initialValue) : totalAmount


	useEffect(() => {
		if (giftCardPayment) {
			setGiftCard(giftCardPayment)
			setIsSufficient((Number(giftCardPayment?.currentBalance) >= newTotalAmount) || isSplitPayment)
		}
	}, [giftCardPayment])

	const fetchGiftCard = () => {
		setLoading(true);
		setIsFetched(true)
		dispatch(redeemGiftCardApi({ storeId: config?.storeId, coupon: code?.toString() || "" })).unwrap().then((res) => {
			setGiftCard(res?.purchasedgiftCard)
			setIsSufficient((Number(res?.purchasedgiftCard?.currentBalance) >= newTotalAmount) || isSplitPayment)
		}).catch((err) => {
			ZenToast({ type: "error", message: "Invalid Gift Card, Please check the coupon code", })
		}).finally(() => {
			setLoading(false)
		})
	};

	const disabledSave = () => {
		if (!giftCard || Number(giftCard?.currentBalance || 0) <= 0) {
			return true
		}
		return false
	}

	const fullPayment = () => {
		handleSave({
			amount: newTotalAmount,
			paidAmount: newTotalAmount,
			giftCardId: giftCard?.id || -1,
			giftCardPayment: giftCard
		})
		tempCode = null
	}
	const partialPayment = () => {
		const tempPaidAmount = Number(giftCard?.currentBalance || 0)
		handleSave({
			amount: tempPaidAmount,
			paidAmount: tempPaidAmount,
			giftCardId: giftCard?.id || -1,
			giftCardPayment: giftCard
		})
		tempCode = null
	}

	const makeGiftcartPayment = () => {
		if (isSplitPayment) {
			if ((Number(giftCard?.currentBalance) > newTotalAmount)) {
				fullPayment()
			} else {
				partialPayment()
			}
		} else {
			if (isSufficient) {
				//single Payment
				fullPayment()
			} else {
				//split payment	
				dispatch(toggleSplitPayment())
				partialPayment()
			}
		}
	}
	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<View>
						{isSplitPayment ? null :
							<View style={styles.header}>
								<ZenText content={'Gift Card Payment'} style={styles.headerTitle} />
								<TouchableOpacity onPress={onClose} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}>
									<ZenIcon name='close' type='antdesign' color={theme?.lightDark} size={24} />
								</TouchableOpacity>
							</View>
						}

						<View style={styles.content}>


							{isSplitPayment ?
								<View style={styles.headerCard}>
									<ZenText content={'Balance'} style={[styles.label, { marginBottom: 0, color: theme?.grey, fontFamily: theme?.bold }]} />
									<ZenText content={CommonService?.currencyStandard(currencySymbol, remainingAmount > 0 ? remainingAmount?.toString() : "0")} style={styles.totalAmount} />
								</View>
								: <View style={styles.headerCard}>
									<ZenText content={'Total Amount'} style={[styles.label, { marginBottom: 0, color: theme?.grey, fontFamily: theme?.bold }]} />
									<ZenText content={CommonService?.currencyStandard(currencySymbol, newTotalAmount?.toString())} style={styles.totalAmount} />
								</View>}

							<CustomSearchBar
								inputRef={inputRef}
								placeholder='Enter Coupon Code'
								search={code}
								setSearch={(text) => { setCode(text); tempCode = text }}
								toggleOffset={() => { }}
								backgroundColor={theme?.iceWhite}
								leftIcon={false}
								border={true}
								height={50}
								autoCapitalize='characters'
								rightComponent={<TouchableOpacity
									style={[styles.applyButton, !code && styles?.disabledBtn]}
									onPress={fetchGiftCard}
									disabled={loading || !code}
								>
									{loading ? <ActivityIndicator color={theme?.light} /> :
										<ZenText content={'Verify'} style={[styles.applyText, !code && { color: theme?.disableTextColor }]} />}
								</TouchableOpacity>}
							/>

							{giftCard == null ?
								(!isFetched || loading) ? null :
									<View style={{ height: 150 }}>
										<ZenEmptyComponent req={require("../../../../assets/no_data_image.webp")} text='No Such Gift Card Found' style={{ fontSize: theme?.smallerFontSize, top: -20 }} imageStyle={{ width: 150, height: 150 }} />
									</View>
								:
								(
									<View style={styles.card}>
										<View style={styles.cardHeader}>
											<View>
												<ZenText content={'Available Balance'} style={styles.cardTitle} />
												<ZenText content={CommonService?.currencyStandard(currencySymbol, giftCard.currentBalance?.toString() || "0")} style={styles.balanceText} />
											</View>
											<View style={styles.badge}>
												<ZenIcon type='antdesign' name='checkcircle' size={13} color={theme?.wildGreen} />
												<ZenText content={'Active'} style={styles.badgeText} />
											</View>
										</View>

										<View style={styles.divider} />

										<View style={styles.cardFooter}>
											<View style={styles.infoRow}>
												<ZenIcon type='entypo' name='ticket' size={16} color={theme?.disabledGray500} />
												<ZenText content={giftCard.couponCode} style={styles.infoText} />
											</View>
											<View style={styles.infoRow}>
												<ZenIcon type='entypo' name='calendar' size={16} color={theme?.disabledGray500} />
												<ZenText content={`Exp: ${giftCard.expiryDate ?? 'No Expiry'}`} style={styles.infoText} />
											</View>
										</View>

										<View style={styles.historyPreview}>
											<ZenIcon type='feather' name='arrow-up-right' size={14} color={theme?.blue600} />
											<ZenText content={`Last: ${giftCard?.transactionHistory[0]?.transactionType} (${CommonService?.currencyStandard(currencySymbol, giftCard.transactionHistory[0]?.transactionAmount?.toString() || "0")})`} style={styles.historyText} />
										</View>
									</View>
								)}
						</View>

						{(isSufficient || !giftCard || isSplitPayment) ? null : <ZenText content={"Gift card balance is insufficient. Please use split payment."} style={{ color: theme?.red500, fontFamily: theme?.medium, fontSize: theme?.errorFontSize, textAlign: "center", paddingBottom: 15 }} />}


						{/* Footer Actions */}
						<View style={styles.footer}>
							<TouchableOpacity style={[styles.cancelBtn, isSplitPayment && { backgroundColor: theme?.lightBackgroundColor }]} onPress={onClose}>
								<ZenText content={isSplitPayment ? 'Back' : "Cancel"} style={styles.cancelBtnText} />
							</TouchableOpacity>
							<TouchableOpacity
								style={[styles.addBtn, disabledSave() && styles.disabledBtn]}
								disabled={disabledSave()}
								onPress={makeGiftcartPayment}
							>
								<ZenText content={(isSufficient || !giftCard) ? 'Make Payment' : 'Split Payment'} style={[styles.addBtnText, disabledSave() && { color: theme?.disableTextColor }]} />
							</TouchableOpacity>
						</View>
					</View>
				)
			}}
		</ThemeConsumer>
	);
};

const style = (theme: Theme) => StyleSheet.create({
	content: {
		gap: 25,
		paddingVertical: 24
	},
	headerCard: {
		alignItems: 'center'
	},
	totalAmount: { fontSize: theme?.bigFontSize + 10, fontFamily: theme?.bold, color: theme?.primary },
	label: {
		fontSize: theme?.errorFontSize,
		fontFamily: theme?.medium,
		color: theme?.disabledGray500,
		marginBottom: 8,
		textTransform: 'uppercase',
		letterSpacing: 0.5,
	},

	header: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingBottom: 16,
		borderBottomWidth: 1,
		borderBottomColor: theme?.softSlate,
	},
	headerTitle: {
		fontSize: theme?.mediumFontSize,
		fontFamily: theme?.bold,
		color: theme?.lightDark,
	},
	applyButton: {
		backgroundColor: theme?.primary,
		paddingHorizontal: 20,
		paddingVertical: 12,
		borderRadius: 8,
		justifyContent: 'center',
	},
	applyText: {
		color: theme?.light,
		fontFamily: theme?.bold,
		fontSize: theme?.smallHeaderFontSize
	},
	card: {
		backgroundColor: theme?.light,
		borderRadius: 20,
		padding: 20,
		borderWidth: 1,
		borderColor: theme?.softSlate,
		shadowColor: theme?.primary,
		shadowOffset: { width: 0, height: 10 },
		shadowOpacity: 0.1,
		shadowRadius: 20,
		elevation: 5,
	},
	cardHeader: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
	},
	cardTitle: {
		fontSize: theme?.smallHeaderFontSize,
		color: theme?.disabledGray500,
		fontFamily: theme?.medium
	},
	balanceText: {
		fontSize: theme?.headerFontSize,
		fontFamily: theme?.bold,
		color: theme?.lightDark,
		marginTop: 4,
	},
	badge: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: theme?.lightTealGreen,
		paddingHorizontal: 10,
		paddingVertical: 4,
		borderRadius: 20,
		gap: 4,
	},
	badgeText: {
		color: theme?.wildGreen,
		fontSize: theme?.badgeFontSize,
		fontFamily: theme?.bold
	},
	divider: {
		height: 1,
		backgroundColor: theme?.softSlate,
		marginVertical: 15,
	},
	cardFooter: {
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	infoRow: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 6,
	},
	infoText: {
		fontSize: theme?.errorFontSize,
		color: theme?.grey,
		fontFamily: theme?.medium
	},
	historyPreview: {
		marginTop: 15,
		backgroundColor: theme?.iceWhite,
		padding: 10,
		borderRadius: 10,
		flexDirection: 'row',
		alignItems: 'center',
		gap: 8,
	},
	historyText: {
		fontSize: theme?.miniFontSize,
		fontFamily: theme?.medium,
		color: theme?.disabledGray500,
	},


	footer: {
		flexDirection: 'row',
		paddingTop: 16,
		gap: 12,
		borderTopWidth: 1,
		borderTopColor: theme.softSlate,
	},
	cancelBtn: {
		flex: 1,
		paddingVertical: 14,
		alignItems: 'center',
		borderRadius: 12,
		backgroundColor: theme?.iceWhite,
	},
	cancelBtnText: {
		color: theme?.disabledGray500,
		fontSize: theme?.smallFontSize,
		fontFamily: theme?.medium,
	},
	addBtn: {
		flex: 2,
		backgroundColor: theme?.primary,
		paddingVertical: 14,
		alignItems: 'center',
		borderRadius: 12,
	},
	disabledBtn: {
		backgroundColor: theme?.disableGray,
	},
	addBtnText: {
		color: theme?.light,
		fontSize: theme?.smallFontSize,
		fontFamily: theme?.medium,
	}
});

export default GiftCardPayment;